var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('cookie-law',{attrs:{"theme":"royal","button-text":_vm.$t('cookieLawButton')}},[_c('div',{staticClass:"standard-font-family",attrs:{"slot":"message"},slot:"message"},[_vm._v("\n      "+_vm._s(_vm.$t('cookiesLawMessage'))+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f3c997c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 